var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"on-manager":_vm.onManager,"hiddenKeys":_vm.hiddenKeys,"nameRules":_vm.nameRules,"status-module":"commonalert","resource":_vm.resource}})
}
var staticRenderFns = []

export { render, staticRenderFns }